import { render, staticRenderFns } from "./TDirectReports.vue?vue&type=template&id=9146282a&scoped=true"
import script from "./TDirectReports.vue?vue&type=script&lang=js"
export * from "./TDirectReports.vue?vue&type=script&lang=js"
import style0 from "./TDirectReports.vue?vue&type=style&index=0&id=9146282a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9146282a",
  null
  
)

export default component.exports